import CBSearchTextFieldController from "../controller/CBSearchTextFieldController";

const CBEmailSearchFilter = () => {

    return (
        <CBSearchTextFieldController
            idField="email"
            formName="email"
            label="email"
        />
    )
}

export default CBEmailSearchFilter;